/* @flow */
import { observable, action } from 'mobx';

import { ApiModel } from 'api/ApiModel';

export type TypePropsCostCenter = {
  additional_info: any,
  assets: Object,
  code: string,
  description: string,
  id: string,
  name: string,
  projects: number,
  status: boolean,
  trading_account: Object,
};

export type TypeCostCenterDetailsStore = {|
  details: ?TypePropsCostCenter,
  loadDetails: () => {},
  resetStore: () => {},
|};

export default class CostCenterDetailsStore extends ApiModel {
  @observable details: ?TypePropsCostCenter = null;
  @observable loading = true;

  @action async loadDetails(id: string, load = true): Promise<void> {
    this.loading = load;

    try {
      this.details = await this.api.getResource('cost-centres/' + id);
    } catch (e) {
      console.log(e, 'catching ERRORS');
    }

    this.loading = false;
  }

  @action resetStore() {
    this.details = null;
  }
}
